<template>
    <div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="$vuetify.lang.t('$vuetify.groupNormalWorkday.searchBy')"
                        solo
                        height="40px"
                        @keyup.enter="getGroupNormalWorkdaysPagination()">
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        @click="searchGroupNormalWorkdays()"
                        height="40px"
                        color="primary"
                        outlined>
                        {{ $vuetify.lang.t('$vuetify.groupNormalWorkday.search') }}
                    </v-btn>
                </div>
            </div>
            <div>
                <v-btn
                    v-if="permissionCreate"
                    :disabled="!branch"
                    height="40px"
                    @click="createNewGroup()"
                    color="primary">
                    + {{ $vuetify.lang.t('$vuetify.groupNormalWorkday.createGroup') }}
                </v-btn>
            </div>
        </div>
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalGroupWorkdays"
                :items="groupWorkdays"
                :loading="loading">
                <template v-slot:[`item.action`]="{ item }">
                    <div class="action">
                        <v-icon
                            v-if="permissionUpdate"
                            class="mr-2"
                            @click="updateGroupWorkday(item.id)">
                            edit
                        </v-icon>
                        <v-icon
                            v-if="permissionDelete"
                            class="mr-2"
                            @click="openModalDelete(item)">
                            delete
                        </v-icon>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>

        <delete-modal
            ref="modalDeleteGroup"
            @success-deleted="deleteSuccess()"
            :deleteForm="deleteForm"/>
    </div>
</template>

<script>
import DeleteModal from '@/components/modal/DeleteModal'
import permissionConstant from '@/constants/permissions.js'
export default {
    name: 'GroupNormalWorkday',

    components: {
        DeleteModal
    },
    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.groupNormalWorkday.groupName'), value: 'name', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.groupNormalWorkday.updateAt'), value: 'updated_at', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.groupNormalWorkday.createdAt'), value: 'created_at', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.groupNormalWorkday.workDay'), value: 'workday', width: '20%', sortable: false },
                { text: this.$vuetify.lang.t('$vuetify.groupNormalWorkday.numberOfPeople'), value: 'number_of_people', width: '20%' },
                { text: '', value: 'action', width: '10%', sortable: false }
            ]
        },
        questionDelete () {
            return this.$vuetify.lang.t('$vuetify.groupNormalWorkday.questionDelete')
        },
        msgDeleteSuccess () {
            return {
                title: this.$vuetify.lang.t('$vuetify.groupNormalWorkday.congratulation'),
                text: this.$vuetify.lang.t('$vuetify.groupNormalWorkday.msgDeleteSuccess'),
                type: 'success'
            }
        }
    },
    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            groupWorkdays: [],
            totalGroupWorkdays: 0,
            loading: false,
            branch: null,
            permissionCreate: true,
            permissionUpdate: true,
            permissionDelete: true,
            deleteForm: {
                header: '',
                content: '',
                path: ''
            }
        }
    },

    methods: {
        async searchGroupNormalWorkdays () {
            this.options.page = 1
            await this.getGroupNormalWorkdaysPagination()
        },

        async getGroupNormalWorkdaysPagination () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `group/workdays?branch=${this.branch}&page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.groupWorkdays = res.data.data
                this.totalGroupWorkdays = res.data.total
                this.loading = false
            }
        },

        createNewGroup () {
            this.$router.push({ name: 'TimeTableSetting/CreateGroupWorkday' }, () => {})
        },

        updateGroupWorkday (id) {
            this.$router.push({ name: 'TimeTableSetting/EditGroupWorkday', params: { id: id } })
        },

        async getBranch () {
            this.branch = localStorage.getItem('currentBranchId')
            if (this.branch) {
                await this.getGroupNormalWorkdaysPagination()
            }
        },

        async openModalDelete (group) {
            this.deleteForm.header = this.$vuetify.lang.t('$vuetify.groupNormalWorkday.deleteGroup')
            this.deleteForm.content = this.questionDelete.replace('$Name', group.name)
            this.deleteForm.path = `group/workdays/delete/${group.id}`
            this.$refs.modalDeleteGroup.dialog = true
        },

        async deleteSuccess () {
            this.$notify(this.msgDeleteSuccess)
            await this.getGroupNormalWorkdaysPagination()
        },

        checkPermission () {
            this.permissionCreate = this.$util.checkPermission(permissionConstant.groupWorkday.create)
            this.permissionUpdate = this.$util.checkPermission(permissionConstant.groupWorkday.update)
            this.permissionDelete = this.$util.checkPermission(permissionConstant.groupWorkday.delete)
        }
    },

    async mounted () {
        await this.getBranch()
    },

    watch: {
        options: {
            async handler () {
                if (this.branch) {
                    await this.getGroupNormalWorkdaysPagination()
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
    box-shadow: none !important;
    border: 1px solid #a8a8a8 !important;
}

</style>
